import React from "react";

const Blog1 = () => {



  return (
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative bg-main-gray pb-16 md:pb-[120px]">
          <img
            src="./assets/images/home-nine/hero-bg.png"
            alt=""
            className="absolute z-0 mx-auto cta_bg_anim h-full w-full"
          />

          <div
            className="win-grid win-grid-bg w-full h-full absolute left-0 top-0 z-0"
            id="win-grid"
          />
          <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
            <div className="flex justify-center">
              <img src="assets/images/home-one-hero-circle-shadow.svg" alt="" />
            </div>
          </div>
          <div className="theme-container mx-auto h-fit w-fit relative z-0">
            <div className="mt-[120px] md:mt-[200px] w-fit mx-auto relative">
              <h1 data-aos="fade" className="text-main-black text-34 font-semibold w-full text-center max-w-[500px]">
                Wellness OPD: Your first step to preventive healthcare
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[130px]" data-aos="fade">
        <div className="theme-container mx-auto w-full">
          <div className="grid grid-cols-6 md:grid-cols-12 items-center">
            <div className="col-span-6">
              <h1 className="text-24 sm:text-34 leading-[55px] tracking-tight font-semibold text-main-black">
                Overview
              </h1>
              <p className="max-w-[533px] text-16 sm:text-24 leading-[40px] text-paragraph mt-2.5 md:mt-3.5">
                In today’s healthcare system, most people only seek medical attention when symptoms become severe, or they’re forced to take time off work or personal life. This reactive approach often means that by the time a condition is detected, it might already be advanced, making treatment more complex and costly. Wellness OPD takes a proactive approach to health, prioritizing prevention rather than treatment.
              </p>
            </div>
            <div className="col-span-6 flex justify-center items-center mt-5 md:mt-0">
              <img
                src="assets/images/home-three/blogs/1.jpg"
                alt=""
                className="w-full rounded-[40px]"
              />
            </div>
          </div>

          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            What is Wellness OPD?
          </h4>
          <p className="text-paragraph mt-[10px]">
          Wellness OPD stands for “Wellness Outpatient Department,” offering services designed to monitor and enhance your overall health before serious issues arise. It includes regular health checkups, preventive screenings, expert consultations, and lifestyle assessments — all designed to catch potential problems early.
          </p>

          <p className="text-paragraph mt-[10px] mb-10">
            The key benefit of Wellness OPD is that it helps identify risk factors or underlying conditions long before they escalate. Regular checkups for heart health, blood pressure, cholesterol levels, diabetes, and mental wellness ensure that you’re not just waiting for symptoms to appear. This early detection helps in creating personalized health plans to prevent future complications.
          </p>
          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            Who Can Benefit from Wellness OPD?
          </h4>
          <p className="text-paragraph mt-[10px] mb-[10px]">
            Anyone can benefit from preventive healthcare! Wellness OPD services are ideal for individuals who want to stay on top of their health, manage chronic conditions, or simply prioritize their wellness. These services are beneficial for:
          </p>
          <p className="text-paragraph">
            1. Families looking to maintain the health of every member, from children to seniors.
          </p>
          <p className="text-paragraph">
           2. Working professionals who need accessible healthcare without taking too much time off work. 
          </p>
          <p className="text-paragraph">
            3. Older adults who want to monitor chronic conditions such as diabetes, hypertension, and arthritis.
          </p>

           <p className="text-paragraph mb-10 mt-[30px]">
            By integrating Wellness OPD into your routine, you’re making a smart choice for a healthier future, reducing future healthcare costs, and improving your quality of life.
          </p>
          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
           Conclusion
          </h4>
          <p className="text-paragraph mb-10 mt-[10px]">
           Taking charge of your health today can help you avoid costly and painful treatments tomorrow. Wellness OPD is a great investment in your well-being, offering a blend of convenience, accessibility, and affordability. Start today and experience the peace of mind that comes with proactive healthcare.
          </p>
        </div>
      </section>
      {/* blog end  */}


    </main>
  );
};

export default Blog1;
